// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== TabQuestionsReponses — EPIC-18 / Story 18.7 — Thread WhatsApp ===== */

/* ── Container ───────────────────────────────────────────────────────────── */

.qr-thread-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* ── Thread zone ─────────────────────────────────────────────────────────── */

.qr-thread {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  margin: 0.5rem 0;
  min-height: 300px;
  max-height: 500px;
}

.qr-empty {
  padding: 2rem;
  color: #9ca3af;
  font-size: 1.3rem;
  text-align: center;
  margin: auto;
}

.qr-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  color: #6b7280;
  font-size: 1.3rem;
  margin: auto;
}

.qr-error {
  font-size: 1.2rem;
  color: #ef4444;
}

/* ── Bubble ──────────────────────────────────────────────────────────────── */

.qr-bubble {
  max-width: 75%;
  padding: 0.6rem 1rem;
  border-radius: 0.75rem;
  position: relative;
  line-height: 1.45;
}

/* Messages d'autres prestataires (gauche) */
.qr-bubble--prestataire {
  align-self: flex-start;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-bottom-left-radius: 0.25rem;
}

/* Mes propres messages (droite) */
.qr-bubble--mine.qr-bubble--prestataire {
  align-self: flex-end;
  background: #fff7ed;
  border-color: #fed7aa;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.75rem;
}

/* Messages admin/Centralis (gauche, accent orange) */
.qr-bubble--admin {
  align-self: flex-start;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-left: 3px solid #f97316;
  border-bottom-left-radius: 0.25rem;
}

.qr-bubble-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.qr-bubble-author {
  font-size: 1.1rem;
  font-weight: 600;
  color: #6b7280;
}

.qr-bubble--admin .qr-bubble-author {
  color: #f97316;
}

.qr-bubble--mine .qr-bubble-author {
  color: #374151;
}

.qr-bubble-date {
  font-size: 1rem;
  color: #9ca3af;
  margin-left: auto;
}

.qr-bubble-identifiant {
  font-size: 0.9rem;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 50px;
  padding: 0.1rem 0.5rem;
}

.qr-bubble-body {
  font-size: 1.25rem;
  color: #374151;
  white-space: pre-wrap;
}

/* ── Input bar ───────────────────────────────────────────────────────────── */

.qr-input-bar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem 0;
  border-top: 1px solid #e5e7eb;
}

.qr-input-textarea {
  width: 100%;
  min-height: 50px;
  padding: 0.6rem 1rem;
  font-size: 1.25rem;
  font-family: inherit;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  resize: none;
  box-sizing: border-box;
}

.qr-input-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

.qr-input-textarea::placeholder {
  color: #9ca3af;
}

.qr-input-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.qr-char-count {
  font-size: 1rem;
  color: #9ca3af;
}

.qr-send-error {
  font-size: 1rem;
  color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/TabQuestionsReponses.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,+EAA+E;;AAE/E;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* ===== TabQuestionsReponses — EPIC-18 / Story 18.7 — Thread WhatsApp ===== */\n\n/* ── Container ───────────────────────────────────────────────────────────── */\n\n.qr-thread-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* ── Thread zone ─────────────────────────────────────────────────────────── */\n\n.qr-thread {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  margin: 0.5rem 0;\n  min-height: 300px;\n  max-height: 500px;\n}\n\n.qr-empty {\n  padding: 2rem;\n  color: #9ca3af;\n  font-size: 1.3rem;\n  text-align: center;\n  margin: auto;\n}\n\n.qr-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  color: #6b7280;\n  font-size: 1.3rem;\n  margin: auto;\n}\n\n.qr-error {\n  font-size: 1.2rem;\n  color: #ef4444;\n}\n\n/* ── Bubble ──────────────────────────────────────────────────────────────── */\n\n.qr-bubble {\n  max-width: 75%;\n  padding: 0.6rem 1rem;\n  border-radius: 0.75rem;\n  position: relative;\n  line-height: 1.45;\n}\n\n/* Messages d'autres prestataires (gauche) */\n.qr-bubble--prestataire {\n  align-self: flex-start;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-bottom-left-radius: 0.25rem;\n}\n\n/* Mes propres messages (droite) */\n.qr-bubble--mine.qr-bubble--prestataire {\n  align-self: flex-end;\n  background: #fff7ed;\n  border-color: #fed7aa;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n/* Messages admin/Centralis (gauche, accent orange) */\n.qr-bubble--admin {\n  align-self: flex-start;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-left: 3px solid #f97316;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.qr-bubble-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.qr-bubble-author {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.qr-bubble--admin .qr-bubble-author {\n  color: #f97316;\n}\n\n.qr-bubble--mine .qr-bubble-author {\n  color: #374151;\n}\n\n.qr-bubble-date {\n  font-size: 1rem;\n  color: #9ca3af;\n  margin-left: auto;\n}\n\n.qr-bubble-identifiant {\n  font-size: 0.9rem;\n  color: #6b7280;\n  background: #f3f4f6;\n  border-radius: 50px;\n  padding: 0.1rem 0.5rem;\n}\n\n.qr-bubble-body {\n  font-size: 1.25rem;\n  color: #374151;\n  white-space: pre-wrap;\n}\n\n/* ── Input bar ───────────────────────────────────────────────────────────── */\n\n.qr-input-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.75rem 0;\n  border-top: 1px solid #e5e7eb;\n}\n\n.qr-input-textarea {\n  width: 100%;\n  min-height: 50px;\n  padding: 0.6rem 1rem;\n  font-size: 1.25rem;\n  font-family: inherit;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.qr-input-textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n.qr-input-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.qr-input-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.qr-char-count {\n  font-size: 1rem;\n  color: #9ca3af;\n}\n\n.qr-send-error {\n  font-size: 1rem;\n  color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
